import React, { memo } from 'react';
import cn from 'classnames';

var styles = {"bar":"stepped-progress-bar__bar_9zasv","positive":"stepped-progress-bar__positive_9zasv","attention":"stepped-progress-bar__attention_9zasv","negative":"stepped-progress-bar__negative_9zasv","link":"stepped-progress-bar__link_9zasv","tertiary":"stepped-progress-bar__tertiary_9zasv","secondary":"stepped-progress-bar__secondary_9zasv","primary":"stepped-progress-bar__primary_9zasv","accent":"stepped-progress-bar__accent_9zasv"};
require('./index.css')

var StepBar = memo(function (_a) {
    var isDone = _a.isDone, _b = _a.view, view = _b === void 0 ? 'positive' : _b, classNameStep = _a.classNameStep;
    return (React.createElement("span", { "data-test-id": isDone ? 'on' : 'off', className: cn(styles.bar, isDone && styles[view], classNameStep) }));
});

export { StepBar };
